<!-- 项目文件 -->
<template>
<div>
    <div class="w100p pb40 pt40">
        <div class="w1200 mauto">
            <div class="textc mt20 mb20">
                <p class="fs36 c333 disinblock posre">
                    <span class="border-bottom1">
                        学车指南
                    </span>
                </p>
            </div>
            <div class="w100p overhidden">
                
                    <ul class="disinblock w100p ml-10 demo ">
                        <router-link to="Guide"  >
                        <li class="floatl minh215 disinblock w30p bg111 ml36 pl10 box pt30 pb20 pl20 ">
                           <div class="overflow alit posre">
                               <span class="fs40 ccccc floatl fbold">
                                   01
                               </span>
                            <span class="fs14 cfff floatr bg1f8 posab right0 toleft h25 lh25 w45 textc">
                                科二
                            </span>
                           </div>
                           <h2 class="fs18 fbold c333 pt15 pb15">
                            倒车入库
                           </h2>
                           <p class="fs14 c666">
                                倒库出库并不难，系带挂挡左灯闪，
                           </p>
                            <p class="fs14 c666">
                                踩住离合放手刹，慢抬离合起步缓。
                            </p>
                        </li>
                        </router-link>
                        <router-link to="Guide"  >
                        <li class="floatl minh215 disinblock w30p bg111 ml36 pl10 box pt30 pb20 pl20 ">
                            <div class="overflow alit posre">
                                <span class="fs40 ccccc floatl fbold">
                                    02
                                </span>
                                <span class="fs14 cfff floatr bg1f8 posab right0 toleft h25 lh25 w45 textc">
                                    科二
                                </span>
                            </div>
                            <h2 class="fs18 fbold c333 pt15 pb15">
                                直角拐弯
                            </h2>
                            <p class="fs14 c666">
                                弯前一档车速慢， 摆正车身是关键
                            </p>
                            <p class="fs14 c666">
                            左边三十公分好， 不能压线要记牢。
                            </p>
                        </li>
                        </router-link>
                        <router-link to="Guide"  >
                        <li class="floatl minh215 disinblock w30p bg111 ml36 pl10 box pt30 pb20 pl20 ">
                            <div class="overflow alit posre">
                                <span class="fs40 ccccc floatl fbold">
                                    03
                                </span>
                                <span class="fs14 cfff floatr bg1f8 posab right0 toleft h25 lh25 w45 textc">
                                科二
                                </span>
                            </div>
                            <h2 class="fs18 fbold c333 pt15 pb15">
                                侧方停车
                            </h2>
                            <p class="fs14 c666">
                                侧方停车在右边，中轴去瞄右边线。
                            </p>
                            <p class="fs14 c666">
                                直行慢过右边角，倒车要把右镜看。
                            </p>
                        </li>
                        </router-link>
                    </ul>
                    
                
                <div class="textc mt20 mb20">
                    <router-link to="Guide"  >
                        <span class="cursor disinblock fs18 bradius8 border1f8 c1f8 pt10 pb10 pl45 pr45">查看更多>></span>
                    </router-link>
                </div>
            </div>
        </div>
    </div> 
</div>

</template>

<script>
    export default {
        data() {
            return {

            };
        },
        methods: {

        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bg111 {
        background-image: url('../../public/img/img71.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .toleft:after {
        content: ' ';
        height: 0;
        position: absolute;
        width: 0;
        border: 12.5px solid transparent;
        border-right-color: #1f82f6;
        top: 0;
        right: 100%;
    }
</style>